<script>
	const Q = require('q');

	const studentLibraryUtilities = require('utilities/studentLibraryUtilities');
	const getFavorites = studentLibraryUtilities.getFavorites;
	const studentGetArticlesRead = studentLibraryUtilities.studentGetArticlesRead;
	const submitArticleNote = studentLibraryUtilities.submitArticleNote;

	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const SL_LOG_FILTER = analyticsUtilities.events.SL_LOG_FILTER;
	const SL_LOG_EDIT = analyticsUtilities.events.SL_LOG_EDIT;

	module.exports = {
		components: {
			'library-product-card': require('components/library-product-card.vue').default,
			'load-mask': require('components/load-mask.vue').default,
			'validated-textarea': require('components/validated-textarea.vue').default,
			'heart-icon': require('components/svg/heart-icon.vue').default,
			'text-to-speech-player-simple': require('components/text-to-speech-player-simple.vue').default
		},
		props: ['tts'],
		modelData: ['libraryArticlesRead', 'libraryFavorites'],
		data() {
			return {
				editing: null,
				loading: false,
				editLoading: {},
				filter: ''
			};
		},
		computed: {
			results() {
				let read = this.libraryArticlesRead || [];
				let favorites = this.libraryFavorites || [];
				let filter = this.filter;
				let list = [...read];
				if (filter === 'favorites') {
					list = [...favorites];
				}
				return list;
			},
			articlesReadNumber() {
				let read = this.libraryArticlesRead || [];
				return read.length;
			},
			favoritesNumber() {
				let favorites = this.libraryFavorites || [];
				return favorites.length;
			},
			wordCount() {
				let read = this.libraryArticlesRead || [];
				let count = 0;
				read.forEach(r => (count += r.wordCount));

				return count;
			}
		},
		methods: {
			onNoteChange(e, item) {
				let n = e.target.value;
				let uuid = item.uuid;
				let p = item.id;
				if (n && p) {
					this.editLoading[uuid] = true;
					fireEvent(SL_LOG_EDIT, {
						pid: p,
						note: n
					});
					submitArticleNote(p, n, item).finally(() => (this.editLoading[uuid] = false));
				}
			}
		},
		watch: {
			filter(val) {
				fireEvent(SL_LOG_FILTER, {
					filter: val
				});
			}
		},
		mounted() {
			this.loading = true;
			Q.all([getFavorites(), studentGetArticlesRead()]).then(() => (this.loading = false));
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	.library-reading-log {
		padding-top: 2rem;
		position: relative;
		min-height: 10rem;

		.library-reading-log-header {
			text-align: right;

			.input-select {
				display: inline-block;
			}
		}

		.log-item-header {
			margin-bottom: 2rem;
			border-bottom: 1px solid $c-grey;
			display: flex;
			align-items: center;
			font-weight: bold;

			.product-title {
				flex: 1;
			}

			.stats-container {
				flex: 2;
				display: flex;
				align-items: center;

				.notes-header {
					flex: 2;
				}

				.stat-row {
					flex: 3;
					.stat {
						margin-right: 1rem;
						display: inline-block;

						.top-stat {
							font-weight: bold;
						}

						.bottom-stat {
							font-weight: normal;
						}
					}
				}
			}
		}

		.log-item {
			position: relative;
			display: flex;
			align-items: end;
			margin-bottom: 2rem;
			padding-bottom: 1rem;
			border-bottom: 1px solid $c-grey;

			.library-product-card {
				flex: 1;
				margin: 0;
			}

			.log-notes {
				flex: 2;

				.validated-textarea textarea {
					min-height: 8rem;
				}

				button {
					margin: 1rem 0;
				}
			}
		}
	}
</style>
<template>
	<div class="library-reading-log">
		<load-mask v-if="loading"></load-mask>
		<div class="library-reading-log-inner wrapper">
			<div class="log-item-header">
				<div class="product-title">
					Library Passages You've Read
					<text-to-speech-player-simple
						v-if="tts"
						@click.native.stop.prevent
						:text="'Library Passages You\'ve Read'"></text-to-speech-player-simple>
				</div>
				<div class="stats-container">
					<div class="notes-header">
						Notes
						<text-to-speech-player-simple
							v-if="tts"
							@click.native.stop.prevent
							:text="'Notes'"></text-to-speech-player-simple>
					</div>
					<div class="stat-row">
						<div class="stat">
							<div class="top-stat">
								{{ favoritesNumber }}
							</div>
							<div class="bottom-stat">
								Favorites
								<text-to-speech-player-simple
									v-if="tts"
									@click.native.stop.prevent
									:text="'Favorites'"></text-to-speech-player-simple>
							</div>
						</div>
						<div class="stat">
							<div class="top-stat">
								{{ articlesReadNumber }}
							</div>
							<div class="bottom-stat">
								Passages Read
								<text-to-speech-player-simple
									v-if="tts"
									@click.native.stop.prevent
									:text="'Passages Read'"></text-to-speech-player-simple>
							</div>
						</div>
						<div class="stat">
							<div class="top-stat">
								{{ wordCount | commaGrouping }}
							</div>
							<div class="bottom-stat">
								Words Read
								<text-to-speech-player-simple
									v-if="tts"
									@click.native.stop.prevent
									:text="'Words Read'"></text-to-speech-player-simple>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="library-reading-log-header">
				<div class="select-container form">
					<div class="input-select">
						<select v-model="filter">
							<option
								value=""
								selected>
								All Passages
							</option>
							<option value="favorites">Favorites</option>
						</select>
					</div>
				</div>
			</div>
			<div
				class="log-item"
				v-for="(item, index) in results">
				<load-mask v-if="editLoading[item.uuid]"></load-mask>
				<library-product-card
					:img="item.img_highres2"
					:img-alt="item.imgAlt"
					:key="item.id"
					:id="item.id"
					:title="item.title"
					:topics="item.libraryTopics"
					:horizontal="true"
					:show-read="false"
					:show-favorite="true"
					:versioned="true"
					:article-index="index"
					:level="((item.canonicalGrade && [item.canonicalGrade]) || item.grades) | getGradeRangeString">
				</library-product-card>
				<div class="log-notes">
					<div>
						<form
							class="submit-form text-centered"
							@submit.prevent>
							<validated-textarea
								class="print-hidden"
								@change.native="onNoteChange($event, item)"
								:value="item.n"
								:placeholder="'You didn\'t add a note for this passage. Add one now!'">
							</validated-textarea>
						</form>
					</div>
				</div>
			</div>
			<div
				v-if="!loading && results && results.length === 0"
				class="text-centered padding-top-large padding-bottom-large">
				<p>Passages you've already read will be available here.</p>
			</div>
		</div>
	</div>
</template>
